import messages from './messages'
export function getBookButtonMessage ({ isActive }) {
    if (isActive) {
        return messages.book
    }
    return messages.viewParking
}
